import { render, staticRenderFns } from "./schoolList.vue?vue&type=template&id=7905e9d8&scoped=true"
import script from "./schoolList.vue?vue&type=script&lang=js"
export * from "./schoolList.vue?vue&type=script&lang=js"
import style0 from "./schoolList.vue?vue&type=style&index=0&id=7905e9d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7905e9d8",
  null
  
)

export default component.exports